import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 6a2 2 0 0 1 1.994 1.85L30 8v16a2 2 0 0 1-1.85 1.994L28 26H4a2 2 0 0 1-1.995-1.85L2 24V8a2 2 0 0 1 1.85-1.995L4 6zm0 7.106H4V24h24zM26 21a1 1 0 0 0-1-1h-4l-.117.007A1 1 0 0 0 20.999 22h4l.117-.007a1 1 0 0 0 .883-.993m-9-1a1 1 0 0 1 .116 1.993l-.117.007h-2a1 1 0 0 1-.116-1.993l.116-.007zM4 8h24v3.106H4z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPoPayments = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPoPayments);
export default Memo;
